import { useTranslation } from 'react-i18next'

// Aviso de cierre por vacaciones (10-14 ago 2026). Deja de renderizarse solo a partir del 17-ago.
const NOTICE_END = new Date('2026-08-17T00:00:00')

export default function VacationNotice({ variant }: { variant: 'repairs' | 'returns' }) {
  const { t } = useTranslation()
  if (new Date() >= NOTICE_END) return null
  return (
    <div className="bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-3 text-center text-sm font-medium">
      🌴 {t(`vacation.${variant}`)}
    </div>
  )
}
